<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (isLoading) {
	<div class="spinner-wrapper">
		<globalictcc-spinner size="large" />
	</div>
} @else {
	@if (hasError$ | async) {
		<globalictcc-error />
	} @else {
		<div class="app-container">
			<globalictcc-header />
			<main>
				<globalictcc-sidebar />
				<section>
					<div class="page-content">
						<router-outlet />
					</div>
					<globalictcc-footer />
				</section>
			</main>
		</div>
		@if (dashboardLoading$ | async) {
			<div
				class="spinner-wrapper spinner-overlay"
				role="status"
				aria-live="polite"
			>
				<globalictcc-spinner size="large" />
			</div>
		}
	}
}
